export const SIGN_IN_SILENT_SUCCESS = 'SIGN_IN_SILENT_SUCCESS'
export const SIGN_IN_SUCCESS = 'SIGN_IN_SUCCESS'
export const SIGN_OUT_SUCCESS = 'SIGN_OUT_SUCCESS'
export const GET_USER_PERMISSIONS_SUCCESS = 'GET_USER_PERMISSIONS_SUCCESS'

export const CREATE_KEY = 'CREATE_KEY'
export const LOAD_KEYS_SUCCESS = 'LOAD_KEYS_SUCCESS'
export const LOAD_MORE_KEYS_SUCCESS = 'LOAD_MORE_KEYS_SUCCESS'
export const CREATE_KEY_SUCCESS = 'CREATE_KEY_SUCCESS'
export const UPDATE_KEY_SUCCESS = 'UPDATE_KEY_SUCCESS'
export const UPDATE_GET_KEYS_REQUEST = 'UPDATE_GET_KEYS_REQUEST'
export const UPDATE_PAGE_NUM = 'UPDATE_PAGE_NUM'
export const DELETE_KEY_SUCCESS = 'DELETE_KEY_SUCCESS'

export const BEGIN_API_CALL = 'BEGIN_API_CALL'
export const END_API_CALL = 'END_API_CALL'
export const API_CALL_ERROR = 'API_CALL_ERROR'

export const GET_KEYS_PERMISSION = 'GET_KEYS_PERMISSION'
export const UPDATE_KEYS_PERMISSION = 'UPDATE_KEYS_PERMISSION'
export const DELETE_KEYS_PERMISSION = 'DELETE_KEYS_PERMISSION'
export const UPLOAD_KEYS_PERMISSION = 'UPLOAD_KEYS_PERMISSION'
export const UPLOAD_KEYS_SUCCESS = 'UPLOAD_KEYS_SUCCESS'
export const UPLOAD_KEYS_PAGE_NUM = 'UPDATE_KEYS_PAGE_NUM'

export const GET_KEY_MAPPINGS_PERMISSION = 'GET_KEY_MAPPINGS_PERMISSION'
export const UPDATE_GET_KEY_MAPPINGS_REQUEST = 'UPDATE_GET_KEY_MAPPINGS_REQUEST'
export const UPDATE_KEY_MAPPINGS_PAGE_NUM = 'UPDATE_KEY_MAPPINGS_PAGE_NUM'
export const LOAD_KEY_MAPPINGS_SUCCESS = 'LOAD_KEY_MAPPINGS_SUCCESS'
export const LOAD_MORE_KEY_MAPPINGS_SUCCESS = 'LOAD_MORE_KEY_MAPPINGS_SUCCESS'
export const ADD_KEY_MAPPINGS_PERMISSION = 'ADD_KEY_MAPPINGS_PERMISSION'
export const ADD_KEY_MAPPINGS_SUCCESS = 'ADD_KEY_MAPPINGS_SUCCESS'
export const DELETE_KEY_MAPPINGS_PERMISSION = 'DELETE_KEY_MAPPINGS_PERMISSION'
export const DELETE_KEY_MAPPINGS_SUCCESS = 'DELETE_KEY_MAPPINGS_SUCCESS'
export const UPDATE_KEY_MAPPINGS_PERMISSION = 'UPDATE_KEY_MAPPINGS_PERMISSION'
export const UPDATE_KEY_MAPPINGS_SUCCESS = 'UPDATE_KEY_MAPPINGS_SUCCESS'
export const UPLOAD_KEY_MAPPINGS_SUCCESS = 'UPLOAD_KEY_MAPPINGS_SUCCESS'

export const GET_USAGE_PERMISSION = 'GET_USAGE_PERMISSION'
export const UPDATE_GET_USAGE_PERMISSIONS_REQUEST =
  'UPDATE_GET_USAGE_PERMISSIONS_REQUEST'
export const UPDATE_USAGE_PERMISSIONS_PAGE_NUM =
  'UPDATE_USAGE_PERMISSIONS_PAGE_NUM'
export const LOAD_USAGE_PERMISSIONS_SUCCESS = 'LOAD_USAGE_PERMISSIONS_SUCCESS'
export const LOAD_MORE_USAGE_PERMISSIONS_SUCCESS =
  'LOAD_MORE_USAGE_PERMISSIONS_SUCCESS'
export const ADD_USAGE_PERMISSION = 'ADD_USAGE_PERMISSION'
export const ADD_USAGE_PERMISSIONS_SUCCESS = 'ADD_USAGE_PERMISSIONS_SUCCESS'
export const DELETE_USAGE_PERMISSION = 'DELETE_USAGE_PERMISSION'
export const DELETE_USAGE_PERMISSIONS_SUCCESS =
  'DELETE_USAGE_PERMISSIONS_SUCCESS'
export const UPDATE_USAGE_PERMISSION = 'UPDATE_USAGE_PERMISSION'
export const UPDATE_USAGE_PERMISSIONS_SUCCESS =
  'UPDATE_USAGE_PERMISSIONS_SUCCESS'
export const UPLOAD_USAGE_PERMISSIONS_SUCCESS =
  'UPLOAD_USAGE_PERMISSIONS_SUCCESS'

export const LOAD_SIGNING_KEYS_SUCCESS = 'LOAD_SIGNING_KEYS_SUCCESS'
export const LOAD_MORE_SIGNING_KEYS_SUCCESS = 'LOAD_MORE_SIGNING_KEYS_SUCCESS'
export const UPDATE_GET_SIGNING_KEYS_REQUEST = 'UPDATE_GET_SIGNING_KEYS_REQUEST'
export const UPDATE_SIGNING_KEYS_PAGE_NUM = 'UPDATE_SIGNING_KEYS_PAGE_NUM'
export const UPDATE_SIGNING_KEYS_SUCCESS = 'UPDATE_SIGNING_KEYS_SUCCESS'
export const UPLOAD_SIGNING_KEYS_SUCCESS = 'UPLOAD_SIGNING_KEYS_SUCCESS'
export const DELETE_SIGNING_KEYS_SUCCESS = 'DELETE_SIGNING_KEYS_SUCCESS'

export const LOAD_ENDORSEMENT_KEYS_SUCCESS = 'LOAD_ENDORSEMENT_KEYS_SUCCESS'
export const LOAD_MORE_ENDORSEMENT_KEYS_SUCCESS =
  'LOAD_MORE_ENDORSEMENT_KEYS_SUCCESS'
export const UPDATE_GET_ENDORSEMENT_KEYS_REQUEST =
  'UPDATE_GET_ENDORSEMENT_KEYS_REQUEST'
export const UPDATE_ENDORSEMENT_KEYS_PAGE_NUM =
  'UPDATE_ENDORSEMENT_KEYS_PAGE_NUM'
export const UPDATE_ENDORSEMENT_KEYS_SUCCESS = 'UPDATE_ENDORSEMENT_KEYS_SUCCESS'
export const UPLOAD_ENDORSEMENT_KEYS_SUCCESS = 'UPLOAD_ENDORSEMENT_KEYS_SUCCESS'
export const DELETE_ENDORSEMENT_KEYS_SUCCESS = 'DELETE_ENDORSEMENT_KEYS_SUCCESS'

export const GET_ENTRAID_ROLES_SUCCESS = 'GET_ENTRAID_ROLES_SUCCESS'
export const UPSERT_ENTRAID_ROLES_SUCCESS = 'UPSERT_ENTRAID_ROLES_SUCCESS'
export const DELETE_ENTRAID_ROLES_SUCCESS = 'DELETE_ENTRAID_ROLES_SUCCESS'

export const SET_CONFIG = 'SET_CONFIG'

/// Action Types
export type BaseActionType = {
  type: string
  payload: unknown
}
